// Our own test identities must not count as customers (port of bankruptbuy BB-836).
//
// The PostHog project excludes test traffic through one cohort ("Internal /
// Test users": person property $internal_or_test_user = true, OR email
// contains @concept.zone), and the Control Center reads every number through
// it. Its email clause misses the address every agent test signup must use
// (conceptzonetech+<tag>@gmail.com): one such browser signup counted as a real
// sign_up_completed in the week of 2026-09-15. On Finseats, where
// signup_complete is server-side, cc-board-e2e's disposable accounts made 34
// of 44 "sign-ups" that week. Same file on both boards; stamping the property
// wherever an identity is identified fixes that without a dashboard edit.

const TEST_EMAIL =
  /(\.local$)|(@example\.(com|net|org|test)$)|(^conceptzone(tech|hq)(\+[^@]*)?@gmail\.com$)|(@concept\.zone$)/i;

export function isInternalOrTestEmail(email: string | null | undefined): boolean {
  return !!email && TEST_EMAIL.test(email.trim());
}

/** Person properties that put this identity in the test cohort. Empty for a real person. */
export function testIdentityProps(email: string | null | undefined): { $internal_or_test_user?: true } {
  return isInternalOrTestEmail(email) ? { $internal_or_test_user: true } : {};
}
